import React, {
  useState,
  useEffect
} from "react";

import api from "../../api";

import {
  useNavigate
} from "react-router-dom";

function ClientsDeletedList() {

  const [clients, setClients] =
    useState([]);

  const navigate =
    useNavigate();

  // =====================
  // FETCH
  // =====================

  useEffect(() => {

    api
      .get(
        "/clients/supprimes"
      )
      .then((res) =>
        setClients(
          res.data
        )
      )
      .catch((err) =>
        console.error(err)
      );

  }, []);

  // =====================
  // RESTORE
  // =====================

  const handleRestore =
    async (id) => {

      if (
        !window.confirm(
          "Confirmer la réinsertion ?"
        )
      ) {
        return;
      }

      try {

        await api.put(
          `/clients/${id}/reinserer`
        );

        setClients(
          (prev) =>
            prev.filter(
              (c) =>
                c.id !== id
            )
        );

      } catch (err) {

        console.error(err);

        alert(
          "Erreur réinsertion"
        );

      }
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="min-h-[100dvh] bg-gray-100 p-3 md:p-6">

      {/* HEADER */}
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-6">

        <h2 className="text-2xl md:text-3xl font-bold">
          Clients supprimés
        </h2>

        <button
          onClick={() =>
            navigate(
              "/dashboard"
            )
          }
          className="bg-indigo-500 hover:bg-indigo-600 transition text-white px-4 py-3 rounded-xl"
        >
          ⬅️ Dashboard
        </button>

      </div>

      {/* CONTENT */}
      <div className="bg-white rounded-2xl shadow overflow-hidden">

        {/* DESKTOP */}
        <div className="hidden md:block overflow-x-auto">

          <table className="min-w-full">

            <thead className="bg-gray-100">

              <tr>

                <th className="px-4 py-3 text-left">
                  Nom
                </th>

                <th className="px-4 py-3 text-left">
                  Téléphone
                </th>

                <th className="px-4 py-3 text-left">
                  Raison
                </th>

                <th className="px-4 py-3 text-left">
                  Date
                </th>

                <th className="px-4 py-3 text-left">
                  Action
                </th>

              </tr>

            </thead>

            <tbody>

              {clients.map(
                (c) => (

                  <tr
                    key={c.id}
                    className="border-t hover:bg-gray-50"
                  >

                    <td
                      className="px-4 py-3 cursor-pointer text-blue-600 hover:underline"
                      onClick={() =>
                        navigate(
                          `/clients/${c.id}`
                        )
                      }
                    >
                      {c.nom}{" "}
                      {
                        c.post_nom
                      }{" "}
                      {
                        c.prenom
                      }
                    </td>

                    <td className="px-4 py-3">
                      {
                        c.telephone
                      }
                    </td>

                    <td className="px-4 py-3">
                      {
                        c.raison_suppression
                      }
                    </td>

                    <td className="px-4 py-3">

                      {c.date_suppression
                        ? new Date(
                            c.date_suppression
                          ).toLocaleDateString()
                        : "-"}

                    </td>

                    <td className="px-4 py-3">

                      <button
                        onClick={() =>
                          handleRestore(
                            c.id
                          )
                        }
                        className="bg-green-600 hover:bg-green-700 transition text-white px-4 py-2 rounded-xl"
                      >
                        Réinsérer
                      </button>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

        {/* MOBILE */}
        <div className="md:hidden p-3 space-y-3">

          {clients.length ===
            0 && (

            <div className="text-center text-gray-500 py-6">
              Aucun client supprimé
            </div>

          )}

          {clients.map(
            (c) => (

              <div
                key={c.id}
                className="border rounded-2xl p-4 shadow-sm bg-white"
              >

                <div
                  className="cursor-pointer"
                  onClick={() =>
                    navigate(
                      `/clients/${c.id}`
                    )
                  }
                >

                  <p className="font-semibold text-lg">
                    {c.nom}{" "}
                    {
                      c.post_nom
                    }
                  </p>

                  <p className="text-sm text-gray-500">
                    {
                      c.telephone
                    }
                  </p>

                  <p className="text-xs mt-2 text-gray-600">
                    {
                      c.raison_suppression
                    }
                  </p>

                </div>

                <button
                  onClick={() =>
                    handleRestore(
                      c.id
                    )
                  }
                  className="mt-4 w-full bg-green-600 hover:bg-green-700 transition text-white py-3 rounded-xl"
                >
                  Réinsérer
                </button>

              </div>

            )
          )}

        </div>

      </div>

    </div>
  );
}

export default ClientsDeletedList;